import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth.service';
import { getDataProjectLinkQueryParams } from './services/data-project/models/data-project.model';
import { FireService } from './services/fire.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
})
export class AppComponent {
    title? = 'bi-viz';
    projectId: string;
    queryData? = 'test';
    isDevMode = environment.production === false;

    readonly linkQueryParams = getDataProjectLinkQueryParams;

    constructor(
        private fire: FireService,
        private auth: AuthService,
        private router: Router
    ) {
        this.projectId = fire.app.options.projectId!;
    }

    public get isSignedIn() {
        return this.auth.isSignedIn;
    }

    public async signIn() {
        const user = await this.auth.singIn().catch((e) => console.error(e));
        this.title = user?.user.uid;
    }

    public async signOut() {
        await this.auth.signOut().catch((e) => console.error(e));
        this.router.navigate(['/login'], { replaceUrl: true });
    }
}
